import { useState } from "react";
import { PromisePool } from "@supercharge/promise-pool";
import { Link } from "react-router-dom";

export function Button({
  type,
  children,
  onClick,
  sizing,
  to,
  className,
  loading,
  variant,
    container,
}) {
  let [action, setAction] = useState({
    loading: false,
    i: 0,
    n: 0,
  });

  if (!variant) variant = "primary";

  let variantColor = "bg-blue-500 hover:bg-blue-600";
  if (variant === "danger") variantColor = "bg-orange-500 hover:bg-orange-600";
  if (variant === "alert") variantColor = "bg-red-500 hover:bg-red-600";

  if (type == "link") {
    return (
      <Link
        to={to}
        className={`${variantColor} text-white rounded cursor-pointer ${
          sizing === "s" ? "p-1" : "p-3"
        } ${className || ""}`}
      >
        {children}
      </Link>
    );
  }
  if (container == "div") {
    return (
      <div
        className={`${variantColor} text-white rounded cursor-pointer ${
          sizing === "s" ? "p-1" : "p-3"
        } ${className || ""}`}
      >
        {children}
      </div>
    );
  }

  return (
    <button
      type={type || "button"}
      onClick={async (e) => {
        if (action.loading) return;
        if (!onClick) return;

        if (onClick.concurrency) {
          let { data, concurrency, action } = onClick;
          setAction({ loading: true, i: 0, n: data.length });
          await PromisePool.for(data)
            .withConcurrency(concurrency)
            .onTaskFinished((item, pool) => {
              setAction({
                loading: true,
                i: pool.processedCount(),
                n: data.length,
              });
            })
            .process(action);
        } else {
          // Or, a single promise
          setAction({ loading: true, i: 0, n: 0 });
          await onClick(e);
        }

        setAction({ loading: false });
      }}
      className={`${variantColor} text-white rounded cursor-pointer ${
        sizing === "s" ? "p-1" : "p-3"
      } ${className || ""}`}
    >
      {loading || action.loading ? (
        <div className={"flex gap-2"}>
          <div>
            <span className={"fa fa-spinner fa-spin"} />
          </div>
          {action.n > 0 && (
            <div>
              {action.i + 1}/{action.n}
            </div>
          )}
        </div>
      ) : (
        children
      )}
    </button>
  );
}
